var DMCAPageMsg = "This is DMCA page. Use tab to go to the next field.";
var inputValue = "";
var inputplaceholder = "";
var typingTimer;                //timer identifier
var doneTypingInterval = 1800;  //time in ms
var tabKeyCode = 9;
var enterKeyCode = 13;
var DisplayUserInput = "";
var speakValueOnKeyPress = "";

function DMCAPageLoad() {
  //debugger;
  responsiveVoice.cancel();
  if ($('#hidVoiceOnOff').val() == 'ON') {
    responsiveVoice.speak(DMCAPageMsg, ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
  }
  DMCACaption(DMCAPageMsg, tabKeyCode);
}


/*------------------------------------------------------------------
      Common Function for Caption.
------------------------------------------------------------------*/
function DMCACaption(newCaptionInput, keyCode) {
  //debugger;
  if (keyCode == tabKeyCode) {
    var oldCaption = "";
    var newCaption = "";
    oldCaption = document.getElementById('txtCaptions').value;
    newCaption = oldCaption + "\n" + newCaptionInput;
    if (oldCaption == "") {
      newCaption = newCaptionInput;
    }
    if (newCaptionInput != "") {
      document.getElementById("txtCaptions").value = newCaption;
      var $textCaptionArea = $('#txtCaptions');
      $textCaptionArea.scrollTop($textCaptionArea[0].scrollHeight);
    }
  }
  if (keyCode == enterKeyCode) {
    var oldCaption = "";
    var newCaption = "";
    oldCaption = document.getElementById('txtCaptions').value;
    newCaption = oldCaption + "\n" + newCaptionInput;
    if (oldCaption == "") {
      newCaption = newCaptionInput;
    }
    if (newCaptionInput != "") {
      document.getElementById("txtCaptions").value = newCaption;
      var $textCaptionArea = $('#txtCaptions');
      $textCaptionArea.scrollTop($textCaptionArea[0].scrollHeight);
    }
  }
}


/*------------------------------------------------------------------
      Common Function for speak which is connected with registration component.ts file.
------------------------------------------------------------------*/
function DMCAresponsiveVoiceSpeak(inputplaceholder, inputValue, keyCode, innerText, eventId, controlType, title, htmlFor, alt, key) {
  //debugger;
  
  if (controlType == "text") {
    if (inputValue == "") {
      DMCAspeakForAnchorTagControlType(inputValue, inputplaceholder, keyCode);
    }
  }
  if (controlType == "textarea") {    
    DMCAspeakForAnchorTagControlType(inputValue, keyCode);
  }
  if (eventId == "PageDMCA") {
    DMCAspeakForAnchorTagControlType(innerText, title, keyCode);
  }

  if (eventId == "lblDMCA") {
    responsiveVoice.cancel();
    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak("DMCA. Use tab to go to the description.", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    HelpCaption("DMCA. Use tab to go to the description. ", keyCode);
    return;
  }

}

/*------------------------------------------------------------------
      Common Function for anchor controls.
------------------------------------------------------------------*/
function DMCAspeakForAnchorTagControlType(innerText, title, keyCode) {
  //debugger;
  responsiveVoice.cancel();
  if ($('#hidVoiceOnOff').val() == 'ON') {
    if (innerText == 'A-') {
      responsiveVoice.speak("A. Minus", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    else {
      responsiveVoice.speak(innerText + ' ' + "This is the end of the page description. Use tab to go to the footer.", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
  }
  DMCACaption(innerText, keyCode);
  //responsiveVoice.speak(title);
  DMCACaption("This is the end of the page description. Use tab to go to the footer.", keyCode);

}

